<template>
  <div class="user-authentication-modal">
    <el-dialog
      :title="$t('system.user_authentication')"
      :close-on-click-modal="false"
      class="diglog-card"
      :visible.sync="dialogVisible"
      width="500px"
      @close="initData"
    >
      <div class="header-line" />
      <div style="width: 420px; font-style: normal;font-weight: 400;font-size: 18px;line-height: 22px;color: #4B5567;">
        <p>{{ $t('tips.EMAIL_verification_code_authenticate_user_access') }}</p>
      </div>
      <el-form ref="valiForm" :model="valiForm" :rules="valiRules" style="margin-top: 30px">
        <el-form-item prop="code">
          <el-input
            v-model="valiForm.code"
            placeholder="Enter your verification code"
            class="search-frame"
            autocomplete="off"
            clearable
          />
          <!-- 发送验证码 -->
          <el-button type="primary" class="send-email" :disabled="isDisabled" @click="sendCode">
            {{ isDisabled ? times + ' ' + $t('system.second_after_regain') : $t('system.send_verification_code') }}
          </el-button>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button>
        <el-button type="primary" :disabled="listLoading" @click="onClickSubmitBtn">{{
          $t('components.submit')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { checkAppAuthCode, fetchMchAppSecretKey, sendAppAuthCode } from '@/api/merchant-manage/merchant-manage'
import { setLocalStorageKeyVal, getLocalStorageVal, removeLocalStorageVal } from '@/utils/helper'

export default {
  name: 'MerchantAppModal',
  props: {
    app_id_second: {
      type: String,
      default: 'default'
    }
  },
  data() {
    const validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input Verification Code'))
      }
      if (value.length < 6 || value.length > 6) {
        return callback(new Error('Please enter 6 digit valid Verification code'))
      }
      return callback()
    }
    return {
      isDisabled: false, // 是否禁用发送验证码
      times: 60, // 一分钟倒计时
      valiForm: {
        code: ''
      },
      valiRules: {
        code: [
          { validator: validateVerifyCode, trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      listLoading: false,
      form: {
        app_id: ''
      }
    }
  },
  mounted() {
    this.isDisabled = false
    this.times = 60
    removeLocalStorageVal('public_key_second')
    removeLocalStorageVal('white_ips_second')
  },
  methods: {
    sendCode() {
      // 发送验证码
      sendAppAuthCode().then(res => {
        this.$message.success(`Successful!`)
      }).catch(() => {
        this.isDisabled = false
        this.times = 60
        removeLocalStorageVal(this.app_id_second)
        clearInterval(this.timer)
      })
      this.isDisabled = true
      this.intervalTime()
    },
    intervalTime() {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        --this.times
        setLocalStorageKeyVal(this.app_id_second, this.times)
        if (this.times <= 0) {
          this.isDisabled = false
          this.times = 60
          removeLocalStorageVal(this.app_id_second)
          clearInterval(this.timer)
        }
      }, 1000)
    },
    initData() {
      this.form = {
        app_id: ''
      }
      this.$nextTick(function() {
        this.$refs['valiForm'].clearValidate()
      })
    },
    changModalStatus(value, app_id) {
      this.dialogVisible = value
      this.form.app_id = app_id
    },
    onClickSubmitBtn() {
      this.$refs['valiForm'].validate((valid) => {
        if (valid) {
          this.listLoading = true
          const params = { auth_code: this.valiForm.code }
          checkAppAuthCode(params).then(res => {
            if (res.data.check_status) {
              this.$message.success('Success')
              this.$emit('showHiddenInfo', res.data)
              this.dialogVisible = false
            } else {
              // 校验不通过
              this.$message.warning('Verification code identification failed.')
            }
          }).finally(() => {
            this.listLoading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.user-authentication-modal {
  .el-dialog__body {
    padding: 30px 20px 0;
  }

  .el-input--medium .el-input__inner {
    height: 45px;
    line-height: 45px;
  }
}
</style>

<style lang="scss" scoped>
.search-frame {
  width: 260px;
}

.send-email {
  height: 43px;
  width: 191px;
  margin-left: 9px;
}
</style>
